import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Row, Col } from 'react-bootstrap';

import { EntradaItensContainer } from './styles';

import ToggleDefault from '~/components/ToggleDefault';
import { Cfop, Tributacao, Produto } from '~/pages/EntradaNFE/protocols';
import { tipoEmbalagens, unidades } from '~/pages/EntradaNFE/data';
import api from '~/services/api';

import { useEntradaNFE } from '~/pages/EntradaNFE/EntradaNFEContext';

import { defineCFOP } from '~/pages/EntradaNFE/functions/Auxiliares';
import {
  buscaInfoTributacaoEntrada,
  somaCampos,
} from '~/pages/EntradaNFE/functions/Procedures';
import {
  moneyFormat,
  roundByRule,
  strPadZeroL,
  toNumberOrZero,
  transformAsCurrency,
} from '~/utils/functions';
import { buscaTributacao } from '~/pages/EntradaNFE/functions/Auxiliares/BuscaTributacao';
import {
  InputText,
  InputNumber,
  InputMoney,
  InputPeso,
  InputSelect,
  InputAsyncSelect,
} from '~/components/NovosInputs';

import { Util } from '~/pages/EntradaNFE/functions/Util';
import { toast } from 'react-toastify';
import { nanoid } from 'nanoid';
import { insertOrUpdate } from '~/utils/masterDetail';
import { TiPencil } from 'react-icons/ti';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { InputIbsCbs } from '~/components/NovosInputs/InputIbsCbs';
import { alimentaDadosIBSCBSCliente } from '~/components/NovosInputs/InputIbsCbs/functions/alimentaDadosIBSCBSCliente';
import { aplicarIbsCbsOuPadrao } from '~/components/NovosInputs/InputIbsCbs/functions/aplicarIbsCbsOuPadrao';

const parseNumericInputValue = (value: string | number | null | undefined) => {
  if (value === null || value === undefined || value === '') return 0;
  return transformAsCurrency(value);
};

const hasIpvFlag = (value: unknown) =>
  value === true || value === 1 || value === '1' || value === 'true';

export const FormItens: React.FC = () => {
  const {
    loja,
    fornecedor,
    perfil,
    produto,
    setProduto,
    setProdutos,
    produtos,
    formItem,
    canUpdate,
    uuidItens,
    setUuidItens,
    masterDetail,
    setMasterDetail,
    formNfe,
    disabledFormItens,
    setBlockSerieNF,
    codIbsCbsRetriever,
    setCodIbsCbsRetriever,
  } = useEntradaNFE();

  type Select = {
    value: string | number;
    label: string;
  };

  interface ItemTotais {
    qtd_embalagem: any;
    qtd_entrada: any;
    val_tabela: any;
    val_tot_desp_acess: any;
    val_tot_desconto: any;
    val_tot_acrescimo: any;
    val_tot_frete: any;
    val_tot_ipi: any;
    val_tot_st: any;
    flg_bonificado: any;
    des_unidade: any;
    des_referencia: any;
    cfop: any;
    cod_tributacao: any;
    val_tot_venda_varejo: any;
  }

  const [tributacoes, setTributacoes] = useState<Tributacao[]>([]);
  const [optsTributacoes, setOptsTributacoes] = useState<Select[]>([]);
  const [cfops, setCfops] = useState<Cfop[]>([]);
  const [optsCfops, setOptsCfops] = useState<Select[]>([]);
  const [tributacao, setTributacao] = useState<any>({} as Tributacao);
  const [tipoEmbalagemOld, setTipoEmbalagemOld] = useState<any>();

  const entradaItensContainerRef = useRef<HTMLDivElement | null>(null);

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    getValues,
    formState,
    setFocus,
    clearErrors,
    setError,
  } = formItem;
  const watchItem = formItem.watch;
  const { errors } = formState;

  const {
    watch,
    getValues: getValuesFormNfe,
    clearErrors: clearErrorsFormNfe,
    setError: setErrorFormNfe,
  } = formNfe;

  useEffect(() => {
    reset({
      flg_bonificado: false,
    });
  }, []);

  const watchFlgBonificado = watchItem('flg_bonificado');
  const watchCodTributacao = watchItem('cod_tributacao');
  const watchQtdEmbalagem = watchItem('qtd_embalagem');
  const watchQtdEntrada = watchItem('qtd_entrada');
  const watchValTabela = watchItem('val_tabela');

  const isProdutoIpv = hasIpvFlag(produto?.flg_ipv);
  const qtdEmbalagemAtual = parseNumericInputValue(watchQtdEmbalagem) || 1;
  const qtdEntradaAtual = parseNumericInputValue(watchQtdEntrada);
  const valTabelaAtual = transformAsCurrency(watchValTabela ?? 0);
  const totalCalculado = qtdEntradaAtual * valTabelaAtual;
  const totalValorUnitario = Number.isFinite(totalCalculado)
    ? totalCalculado
    : 0;
  const totalValorUnitarioFormatado = `R$ ${moneyFormat(
    String(totalValorUnitario),
  )}`;

  const totalTabelaCalculado =
    qtdEmbalagemAtual * qtdEntradaAtual * valTabelaAtual;
  const totalTabelaValor = Number.isFinite(totalTabelaCalculado)
    ? totalTabelaCalculado
    : 0;
  const totalTabelaFormatado = `R$ ${moneyFormat(String(totalTabelaValor))}`;

  const getTributacao = useCallback(
    async (item: any) => {
      if (item.cod_produto && loja && fornecedor) {
        const getTributacaoEntrada = async () => {
          const data = await buscaTributacao(
            loja,
            fornecedor,
            item,
            tributacoes,
          );
          return data;
        };
        if (uuidItens === undefined) {
          getTributacaoEntrada().then((data) => {
            let posTributacao = data;
            const { flg_optante_simples, cod_trib_simples } = fornecedor;
            if (
              flg_optante_simples &&
              [0, 2].includes(item.tipo_tributacao) &&
              cod_trib_simples > 0
            ) {
              posTributacao = cod_trib_simples;
            }

            const tribReg = tributacoes.find(
              (reg) => reg.cod_tributacao === posTributacao,
            );

            setTributacao(tribReg);

            const regTipoEmbalagem = tipoEmbalagens.find((tipoEmbalagem) => {
              return tipoEmbalagem.value === perfil.tipo_unidade;
            });

            setValue('tipo_embalagem', regTipoEmbalagem);

            setValue('cod_tributacao', {
              value: tribReg?.cod_tributacao,
              label: tribReg?.des_tributacao,
              ...tribReg,
            });

            setFocus('qtd_entrada');
          });
        }
      }
    },
    [fornecedor, loja, perfil, setFocus, setValue, tributacoes, uuidItens],
  );

  const watchTipoEmbalagem = watchItem('tipo_embalagem');

  useEffect(() => {
    if (watchTipoEmbalagem && uuidItens === undefined) {
      if (watchTipoEmbalagem.value === 1) {
        produto.des_unidade = produto.des_unidade_compra;
        produto.qtd_embalagem = produto.qtd_embalagem_compra;
      } else {
        produto.des_unidade = produto.des_unidade_venda;
        produto.qtd_embalagem = produto.qtd_embalagem_venda;
      }

      const regUnidade = unidades.find((unidade) => {
        return unidade.value === produto.des_unidade;
      });

      setValue('des_unidade', regUnidade);
      setValue('qtd_embalagem', produto.qtd_embalagem);
      if (tipoEmbalagemOld !== undefined) {
        setFocus('qtd_entrada');
      }
      setTipoEmbalagemOld(watchTipoEmbalagem);
    }
  }, [
    produto,
    setFocus,
    setValue,
    tipoEmbalagemOld,
    uuidItens,
    watchTipoEmbalagem,
  ]);

  useEffect(() => {
    if (tributacao?.cod_tributacao !== undefined) {
      const flgBonificado = getValues('flg_bonificado');
      const selectedCfop = defineCFOP(
        flgBonificado,
        tributacao,
        produto,
        loja,
        fornecedor,
        cfops,
      );

      if (
        selectedCfop !== undefined &&
        selectedCfop.cfop !== undefined &&
        selectedCfop !== null &&
        selectedCfop.cfop !== null &&
        uuidItens === undefined
      ) {
        setValue('cfop', {
          value: selectedCfop.cfop,
          label: `${selectedCfop.cfop} - ${selectedCfop.des_cfop}`,
        });

        setProduto((prevState) => {
          return {
            ...prevState,
            cfop: selectedCfop.cfop,
            flg_ignora_pis_cofins: selectedCfop.flg_ignora_pis_cofins,
          };
        });
      }
    }
  }, [tributacao]);

  useEffect(() => {
    getTributacoes();
  }, []);

  const watchPerfil = watch('cod_perfil');

  useEffect(() => {
    if (watchPerfil) {
      const codPerfil = watchPerfil.value;
      if (codPerfil) {
        getCfops(codPerfil);
      }
    }
  }, [watchPerfil]);

  async function getTributacoes() {
    try {
      const res = await api.get('/tributacao');
      const { success, data, message } = res.data;
      if (!success) {
        throw new Error(message);
      }
      const options = data.map((item: Tributacao) => {
        return {
          value: item.cod_tributacao,
          label: `${item.cod_tributacao} - ${item.des_tributacao}`,
          cod_tributacao: item.cod_tributacao,
          des_tributacao: item.des_tributacao,
          tipo_encerramento_diferido: item.tipo_encerramento_diferido,
          cod_situacao_tributaria: item.cod_situacao_tributaria,
          val_icms: item.val_icms,
          val_reducao: item.val_reducao,
          tipo_tributacao: item.tipo_tributacao,
        };
      });
      setTributacoes(options);
      setOptsTributacoes(options);
    } catch (e: any) {
      console.error(e);
    }
  }

  async function getCfops(codPerfil: string | number | undefined) {
    if (codPerfil) {
      try {
        const res = await api.get(`/perfil-cfop-cliC-fiscal/${codPerfil}`);
        const { success, data, message } = res.data;
        if (!success) {
          throw new Error(message);
        }
        const options = data.map((cfop: Cfop) => {
          return {
            value: cfop.cfop,
            label: `${cfop.cfop} - ${cfop.des_cfop}`,
            ...cfop,
          };
        });
        setCfops(data);
        setOptsCfops(options);
      } catch (e: any) {
        console.error(e);
      }
    }
  }

  useEffect(() => {
    if (watchCodTributacao && !watchCodTributacao.label) {
      const filtered = tributacoes.find(
        (reg) => reg.cod_tributacao === watchCodTributacao.value,
      );

      if (filtered) {
        setTributacao(filtered);

        setValue('cod_tributacao', {
          label: filtered.label,
          value: filtered.value,
        });
      }
    }
  }, [watchCodTributacao, uuidItens]);

  const handleChangeCFOP = useCallback(
    (cfop: any) => {
      if (cfop && produto) {
        setValue('cfop', cfop);
        // atualizar produto com id_ctb do cfop
        produto.cod_id_ctb = cfop.cod_id_ctb;
        produto.flg_ignora_pis_cofins =
          cfop.flg_ignora_pis_cofins || produto.flg_ignora_pis_cofins;
      }
    },
    [produto, setValue],
  );

  const getInfoNcm = useCallback(async () => {
    try {
      const res = await api.get('/entrada-nfe/info-ncm', {
        params: {
          cod_ncm: produto.cod_ncm,
          des_sigla: fornecedor.des_uf,
          cod_tipo_item: produto.cod_tipo_item,
        },
      });
      const { success, data, message } = res.data;
      if (!success || !data) {
        // throw new Error(message);
        return {
          per_pauta_iva_ncm: 0,
          per_fcp_st: 0,
          per_fcp_icms: 0,
        };
      }

      const { per_fcp_icms, per_fcp_st, per_pauta_iva_ncm } = data;

      return {
        per_pauta_iva_ncm,
        per_fcp_st,
        per_fcp_icms,
      };
    } catch (e: any) {
      console.error(e);
    }
  }, [fornecedor, produto]);

  const resolveIbsCbsCode = useCallback((raw: unknown): number | null => {
    if (raw === null || raw === undefined) return null;

    if (typeof raw === 'number') {
      if (!Number.isFinite(raw) || raw <= 0) return null;
      return raw;
    }

    if (typeof raw === 'string') {
      const trimmed = raw.trim();
      if (trimmed === '') return null;
      const num = Number(trimmed);
      if (!Number.isFinite(num) || num <= 0) return null;
      return num;
    }

    if (typeof raw === 'object' && !Array.isArray(raw)) {
      const maybeValue = (raw as any)?.value;
      return resolveIbsCbsCode(maybeValue);
    }

    return null;
  }, []);

  const getEmpresaConfig = (data: any): any => {
    const isNonEmptyObject = (value: unknown): value is any =>
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value) &&
      Object.keys(value).length > 0;

    if (isNonEmptyObject(data.regra_empresa)) return data.regra_empresa;
    if (isNonEmptyObject(data.empresa)) return data.empresa;
    return null;
  };

  const prepareItemForInsertion = useCallback(
    async (totais: ItemTotais, item?: Produto, valIbsCbs?: any) => {
      const {
        qtd_embalagem,
        qtd_entrada,
        val_tabela,
        val_tot_desp_acess,
        val_tot_desconto,
        val_tot_acrescimo,
        val_tot_frete,
        val_tot_ipi,
        val_tot_st,
        flg_bonificado,
        des_unidade,
        des_referencia,
        cfop,
        cod_tributacao,
        val_tot_venda_varejo,
      } = totais;

      if (flg_bonificado && getValues('cfop').value.substring(1, 2) !== '9') {
        setError('cfop', {});
        return toast.warning(
          'Item marcado como Bonificado, Código Fiscal deve ser de bonificação.',
        );
      }

      const qtdEntradaValue = parseNumericInputValue(qtd_entrada);
      const qtdEmbalagemValue = parseNumericInputValue(qtd_embalagem);

      let serializedProduto: any = item || produto;

      const uuid = uuidItens?.uuid || nanoid();
      const num_item =
        serializedProduto?.num_item ||
        Number(produtos[produtos.length - 1]?.num_item || 0) + 1;

      const qtd_total =
        (qtdEntradaValue * qtdEmbalagemValue) / serializedProduto.val_peso;
      const tot_tabela = roundByRule(
        qtd_total * transformAsCurrency(val_tabela),
      );

      serializedProduto = {
        uuid,
        id: uuid,
        cod_seq_nf_item: uuidItens?.cod_seq_nf_item,
        num_item,
        ...serializedProduto,
        des_referencia,
        cfop: cfop.value,
        des_cfop: cfop.label,
        tipo_tributacao: cod_tributacao.tipo_tributacao,
        tipo_trib_entrada: cod_tributacao.tipo_tributacao,
        cod_tributacao: cod_tributacao.value,
        cod_trib_entrada: cod_tributacao.value,
        des_unidade: des_unidade.value,
        qtd_entrada: qtdEntradaValue,
        qtd_embalagem: qtdEmbalagemValue,
        val_tabela: transformAsCurrency(val_tabela),
        val_tot_desp_acess: transformAsCurrency(val_tot_desp_acess || 0),
        val_tot_desconto: transformAsCurrency(val_tot_desconto || 0),
        val_tot_acrescimo: transformAsCurrency(val_tot_acrescimo || 0),
        val_tot_frete: transformAsCurrency(val_tot_frete || 0),
        val_tot_ipi: transformAsCurrency(val_tot_ipi || 0),
        val_tot_st: transformAsCurrency(val_tot_st || 0),
        val_tot_venda_varejo: transformAsCurrency(val_tot_venda_varejo || 0),
        flg_bonificado,
        val_bc_st_xml: 0,
        val_icms_st_xml: 0,
        val_bc_icms_xml: 0,
        val_icms_xml: 0,
        val_produto_xml: serializedProduto.val_produto_xml,
        val_despesa_acessoria_xml: 0,
        val_desconto_xml: 0,
        val_fcp_st_xml: 0,
        val_fcp_icms_xml: 0,
        val_pis_xml: 0,
        val_cofins_xml: 0,
        tot_tabela: transformAsCurrency(tot_tabela || 0),
        val_red_social: 0,
        val_bc_ibs_cbs: 0,
        per_aliq_cbs: 0,
        per_red_cbs: 0,
        val_cbs: 0,
        per_aliq_ibs_est: 0,
        val_ibs_est: 0,
        per_aliq_ibs_mun: 0,
        per_red_ibs: 0,
        val_ibs_mun: 0,
        val_custo_sibscbs: 0,
      };

      const infoNcm = await getInfoNcm();

      if (!infoNcm) return;
      const { per_pauta_iva_ncm, per_fcp_st, per_fcp_icms } = infoNcm;
      serializedProduto.per_pauta_iva_ncm =
        transformAsCurrency(per_pauta_iva_ncm);
      serializedProduto.per_fcp_st = transformAsCurrency(per_fcp_st);
      serializedProduto.per_fcp_icms = transformAsCurrency(per_fcp_icms);

      serializedProduto.val_custo_rep_loja =
        item?.val_custo_rep || produto.val_custo_rep;
      serializedProduto.flg_nao_calc_bc = false;

      if (
        perfil.tipo_operacao === 1 &&
        perfil.tipo_emissao === 1 &&
        tributacao.tipo_tributacao === 3
      ) {
        serializedProduto.cod_sit_trib_entrada = '060';
      } else {
        serializedProduto.cod_sit_trib_entrada = tributacao.cod_sit_tributaria;
      }

      buscaInfoTributacaoEntrada(
        serializedProduto,
        loja,
        fornecedor,
        tributacoes,
        cod_tributacao.value,
        fornecedor.cod_trib_simples,
        cfop.value,
        fornecedor.flg_optante_simples,
      );

      const condisera_st = !fornecedor.flg_fabricante;

      let ibscbs: any = null;

      const codIbsCbsResolved =
        resolveIbsCbsCode(valIbsCbs) ??
        resolveIbsCbsCode(serializedProduto?.cod_ibs_cbs) ??
        resolveIbsCbsCode(codIbsCbsRetriever);

      if (codIbsCbsResolved !== null) {
        serializedProduto.cod_ibs_cbs = codIbsCbsResolved;

        ibscbs = await alimentaDadosIBSCBSCliente({
          itensParaProcessar: serializedProduto,
          codIbsCbsInput: codIbsCbsResolved,
          isItemEditing: !!uuidItens?.uuid,
          ctx: {
            cbxLocalConsumoIndex: 1,
            loja: {
              codCidade: toNumberOrZero(loja.cod_cidade),
              estado: loja.uf,
            },
            empresa: {
              flg_envia_ibs_cbs: getEmpresaConfig(loja)?.flg_envia_ibs_cbs,
              per_cbs_teste: toNumberOrZero(
                getEmpresaConfig(loja)?.per_cbs_teste,
              ),
              per_ibs_mun_teste: toNumberOrZero(
                getEmpresaConfig(loja)?.per_ibs_mun_teste,
              ),
              per_ibs_uf_teste: toNumberOrZero(
                getEmpresaConfig(loja)?.per_ibs_uf_teste,
              ),
            },
            cliMestreCodCidade: toNumberOrZero((fornecedor as any)?.cod_cidade),
          },
        });
      }

      const produtoSelected = ibscbs || serializedProduto;

      await somaCampos(
        fornecedor,
        loja,
        produtoSelected,
        false,
        false,
        condisera_st,
        false,
      );

      const produtosData: any[] = await insertOrUpdate(
        'nf_itens',
        produtoSelected,
        masterDetail,
        setMasterDetail,
      );

      const produtosReordenados = Util.reordenarProdutos(produtosData);

      setProdutos(produtosReordenados);
      await FocusFilter('cod_produto');
    },
    [
      codIbsCbsRetriever,
      fornecedor,
      getInfoNcm,
      getValues,
      loja,
      masterDetail,
      perfil.tipo_emissao,
      perfil.tipo_operacao,
      produto,
      produtos,
      setError,
      setMasterDetail,
      setProdutos,
      tributacao,
      tributacoes,
      resolveIbsCbsCode,
      uuidItens?.cod_seq_nf_item,
      uuidItens?.uuid,
    ],
  );

  const ValRatItemBruto = (
    ValItem: number, // 12.5
    ValRat: number, // 1
    ValTotItem: number, // 50
  ): number => {
    return ValRat > 0 && ValTotItem > 0 ? ValItem * (ValRat / ValTotItem) : 0.0;
  };

  const isFractionalQuantity = () => {
    const { qtd_embalagem, qtd_entrada } = getValues();
    const qtdEmbalagemValue = parseNumericInputValue(qtd_embalagem);
    const qtdEntradaValue = parseNumericInputValue(qtd_entrada);

    const qtdTotal = qtdEmbalagemValue * qtdEntradaValue;
    if (!isProdutoIpv && !Number.isInteger(qtdTotal)) return true;
    return false;
  };

  const handleAddItem = handleSubmit(async () => {
    const {
      qtd_embalagem,
      qtd_entrada,
      val_tabela,
      val_tot_desp_acess,
      val_tot_desconto,
      val_tot_acrescimo,
      val_tot_frete,
      val_tot_ipi,
      val_tot_st,
      flg_bonificado,
      des_unidade,
      des_referencia,
      cfop,
      cod_tributacao,
      val_tot_venda_varejo,
      cod_ibs_cbs,
    } = getValues();
    const qtdEntradaValue = parseNumericInputValue(qtd_entrada);
    const qtdEmbalagemValue = parseNumericInputValue(qtd_embalagem);

    const serieNF = getValuesFormNfe('cod_serie')?.value;

    if (serieNF === undefined || serieNF === '') {
      setBlockSerieNF(false);
      setErrorFormNfe('cod_serie', {
        type: 'required',
        message: 'A série da NF deve ser informada.',
      });
    } else {
      setBlockSerieNF(true);
      clearErrorsFormNfe('cod_serie');
    }

    const {
      cod_produto,
      tipo_movimentacao,
      flg_explosao_compra,
      tipo_forma_explosao,
    } = produto;
    try {
      // Verifica se é explosão
      if (
        tipo_movimentacao === 1 &&
        flg_explosao_compra === true &&
        tipo_forma_explosao === 1
      ) {
        // Efetuar select dos itens filhos
        const res = await api.get('/entrada-nfe/busca-produtos-explosao', {
          params: {
            cod_loja: loja.cod_loja,
            cod_produto,
            cod_fornecedor: fornecedor.cod_fornecedor,
          },
        });

        if (res.data.success && res.data.data.length > 0) {
          for (let i = 0; i < res.data.data.length; i++) {
            const produtoDecomposicao = res.data.data[i];
            const vValTotal: number = parseFloat(val_tabela) * qtdEntradaValue;

            const vQtdKit: number =
              qtdEntradaValue *
              qtdEmbalagemValue *
              Math.trunc(produtoDecomposicao.qtd_decompoe);

            const vValTabela: number =
              (vValTotal * produtoDecomposicao.per_custo_kit) / 100 / vQtdKit;

            // vDespAcessUn
            const val_tot_desp_acess_ex = ValRatItemBruto(
              vValTabela * vQtdKit,
              parseFloat(val_tot_desp_acess),
              vValTotal,
            );

            // vIPIUn
            const val_ipi_ex = ValRatItemBruto(
              vValTabela * vQtdKit,
              parseFloat(val_tot_ipi),
              vValTotal,
            );
            // vSTUn
            const val_icms_st_ex = ValRatItemBruto(
              vValTabela * vQtdKit,
              parseFloat(val_tot_st),
              vValTotal,
            );
            // vDescontoUn
            const val_desconto_ex = ValRatItemBruto(
              vValTabela * vQtdKit,
              parseFloat(val_tot_desconto),
              vValTotal,
            );
            // acrescimo
            const val_acrescimo_ex = ValRatItemBruto(
              vValTabela * vQtdKit,
              parseFloat(val_tot_acrescimo),
              vValTotal,
            );
            // frete
            const val_frete_ex = ValRatItemBruto(
              vValTabela * vQtdKit,
              parseFloat(val_tot_frete),
              vValTotal,
            );
            // varejeo
            const val_varejo_ex = ValRatItemBruto(
              vValTabela * vQtdKit,
              parseFloat(val_tot_venda_varejo),
              vValTotal,
            );
            // vDescSuframaUn
            const vDescSuframaUn_ex = ValRatItemBruto(
              vValTabela * vQtdKit,
              0,
              vValTotal,
            );

            await prepareItemForInsertion(
              {
                qtd_embalagem,
                qtd_entrada: vQtdKit,
                val_tabela: vValTabela,
                val_tot_desp_acess: val_tot_desp_acess_ex,
                val_tot_desconto: val_desconto_ex,
                val_tot_acrescimo: val_acrescimo_ex,
                val_tot_frete: val_frete_ex,
                val_tot_ipi: val_ipi_ex,
                val_tot_st: val_icms_st_ex,
                flg_bonificado,
                des_unidade,
                des_referencia,
                cfop,
                cod_tributacao,
                val_tot_venda_varejo: val_varejo_ex,
              },
              produtoDecomposicao,
              cod_ibs_cbs,
            );
          }
        }
        return;
      }

      await prepareItemForInsertion(
        {
          qtd_embalagem: qtdEmbalagemValue,
          qtd_entrada: qtdEntradaValue,
          val_tabela,
          val_tot_desp_acess,
          val_tot_desconto,
          val_tot_acrescimo,
          val_tot_frete,
          val_tot_ipi,
          val_tot_st,
          flg_bonificado,
          des_unidade,
          des_referencia,
          cfop,
          cod_tributacao,
          val_tot_venda_varejo,
        },
        produto,
        cod_ibs_cbs,
      );
    } catch (error) {
      console.error(error);
    }
  });

  useEffect(() => {
    if (formState.isSubmitSuccessful) {
      handleClearForm();
    }
  }, [formState]);

  const resetFormData = {
    qtd_embalagem: 0,
    qtd_entrada: 0,
    cod_produto: '',
    cod_ibs_cbs: null,
    cfop: '',
    cod_tributacao: '',
    val_tabela: 0,
    des_referencia: '',
    flg_bonificado: false,
    tipo_embalagem: '',
    des_unidade: '',
    val_tot_desp_acess: '',
    val_tot_desconto: '',
    val_tot_acrescimo: '',
    val_tot_frete: '',
    val_tot_venda_varejo: '',
    val_tot_ipi: '',
    val_tot_st: '',
  };

  const handleClearForm = () => {
    setUuidItens(undefined);
    reset(resetFormData);
    setTributacao({} as Tributacao);
    setProduto({} as Produto);
    setCodIbsCbsRetriever(null);
    FocusFilter('cod_produto');
  };

  async function FocusFilter(idInput: string) {
    const input = await document.getElementById(idInput);
    input?.focus();
  }

  async function handleReferencia() {
    const cod_loja = await getValuesFormNfe('cod_loja')?.value;
    const cod_fornecedor = await getValuesFormNfe('cod_pessoa')?.cod_fornecedor;
    const cod_produto = await getValues('cod_produto')?.value;
    const des_referencia = await getValues('des_referencia');
    const qtd_embalagem_compra = await getValues('qtd_embalagem');
    const des_unidade_compra = await getValues('des_unidade').value;
    const res = await api.post('/entrada-nfe/referencia', {
      cod_loja,
      cod_fornecedor,
      cod_produto,
      des_referencia,
      qtd_embalagem_compra,
      des_unidade_compra,
    });
    if (res.data.success) {
      await toast.success(res.data.message);
    } else {
      await toast.warning(res.data.message);
    }
  }

  const handleSelectedProduct = useCallback(
    async (selected: any) => {
      const selectedAny: any = {
        ...selected,
        cod_beneficio_fiscal: strPadZeroL(8, selected?.cod_beneficio_fiscal),
      };

      setValue('des_referencia', selectedAny.des_referencia);
      setValue('cod_produto', selected);
      setValue('flg_bonificado', false);
      clearErrors('cod_produto');

      setProduto(selectedAny);
      setFocus('qtd_entrada');
      if (selected.val_custo_rep) {
        setValue('val_tabela', moneyFormat(selected.val_custo_rep, 4, 4));
      }

      const ibscbs = await aplicarIbsCbsOuPadrao(selectedAny?.cod_ibs_cbs);
      setCodIbsCbsRetriever(ibscbs);
    },
    [clearErrors, setFocus, setProduto, setValue, setCodIbsCbsRetriever],
  );

  return (
    <>
      <Row>
        <Col md={9} sm={12}>
          <InputAsyncSelect
            label="Produto"
            id="cod_produto"
            maxLength={50}
            placeholder="Selecione..."
            title={
              disabledFormItens.isDisabled ? disabledFormItens.placeholder : ''
            }
            name="cod_produto"
            register={register}
            isError={!!formState.errors.cod_produto}
            control={control}
            disabled={!canUpdate || (canUpdate && disabledFormItens.isDisabled)}
            changeSelected={async (selected) => {
              const selectedAny: any = selected;
              await handleSelectedProduct(selectedAny);
              await getTributacao(selectedAny);
            }}
            api={{
              route: '/entrada-nfe/busca-produtos',
              method: 'get',
              bodyParams: {
                loja: getValuesFormNfe('cod_loja')?.value,
                cod_fornecedor: getValuesFormNfe('cod_pessoa')?.cod_fornecedor,
              },
              fields: ['cod_produto', 'des_produto'],
              dependsOf: ['loja'],
              messageForDependsOf:
                'É necessário selecionar a loja na capa da NF',
            }}
          />
        </Col>
        <Col md={3} sm={12}>
          <div className="input-container">
            <InputText
              label="Referência"
              maxLength={50}
              style={{ height: '42px' }}
              placeholder=""
              disabled={
                !canUpdate || (canUpdate && disabledFormItens.isDisabled)
              }
              title={
                disabledFormItens.isDisabled
                  ? disabledFormItens.placeholder
                  : ''
              }
              name="des_referencia"
              register={register}
              toLowerCase={false}
              isError={false}
              control={control}
            />
            <CustomButtonNovo
              style={{ height: '42px' }}
              className="min-button"
              title="Vincular Referência ao Fornecedor"
              onClick={handleReferencia}
              disabled={
                getValues('des_referencia') === '' ||
                getValues('cod_produto')?.value === undefined ||
                !canUpdate ||
                (canUpdate && disabledFormItens.isDisabled)
              }
              icon={TiPencil}
              iconOnly
              iconSize={20}
              ariaLabel="Vincular Referência ao Fornecedor"
            />
          </div>
        </Col>

        <Col md={3} sm={4}>
          <InputIbsCbs
            label="IBS/CBS"
            register={register}
            control={control}
            isError={!!errors.cod_ibs_cbs}
            name="cod_ibs_cbs"
            changeSelected={(value) => {
              clearErrors('cod_ibs_cbs');
              setValue('cod_ibs_cbs', value);
            }}
            valueRetriever={codIbsCbsRetriever}
            disabled={!canUpdate || (canUpdate && disabledFormItens.isDisabled)}
          />
        </Col>

        <Col md={4} sm={8}>
          <InputSelect
            label="Tributação"
            placeholder="Selecione..."
            title={
              disabledFormItens.isDisabled ? disabledFormItens.placeholder : ''
            }
            name="cod_tributacao"
            register={register}
            isError={!!formState.errors.cod_tributacao}
            control={control}
            options={optsTributacoes}
            changeSelected={(selected) => {
              clearErrors('cod_tributacao');

              setValue('cod_tributacao', selected);
            }}
            disabled={!canUpdate || (canUpdate && disabledFormItens.isDisabled)}
          />
        </Col>
        <Col md={4} sm={8}>
          <InputSelect
            label="CFOP"
            placeholder="Selecione..."
            title={
              disabledFormItens.isDisabled ? disabledFormItens.placeholder : ''
            }
            maxLength={50}
            name="cfop"
            register={register}
            isError={!!formState.errors.cfop}
            control={control}
            options={optsCfops}
            changeSelected={(selected: any) => {
              clearErrors('cfop');
              handleChangeCFOP(selected);
              if (selected.value.substring(1, 2) !== '9') {
                setValue('flg_bonificado', false);
              }
            }}
            disabled={!canUpdate || (canUpdate && disabledFormItens.isDisabled)}
          />
        </Col>
        <Col md={1} sm={4}>
          <ToggleDefault
            labelText="Bonificado?"
            setChecked={watchFlgBonificado}
            onSwitch={() => {
              setValue('flg_bonificado', !watchFlgBonificado);
            }}
            disabled={!canUpdate || (canUpdate && disabledFormItens.isDisabled)}
          />
        </Col>
      </Row>

      <Row className="d-flex align-items-center mt-2">
        <Col md={1} sm={4}>
          <p
            style={{
              marginTop: '16px',
              marginBottom: 0,
            }}
          >
            Entrada
          </p>
        </Col>
        <Col ref={entradaItensContainerRef} md={11} sm={12}>
          <EntradaItensContainer>
            <Row className="bg-green">
              <Col md={3} sm={4}>
                <InputSelect
                  label="Tipo da Embalagem"
                  placeholder="Selecione..."
                  title={
                    disabledFormItens.isDisabled
                      ? disabledFormItens.placeholder
                      : ''
                  }
                  name="tipo_embalagem"
                  register={register}
                  isError={false}
                  control={control}
                  options={tipoEmbalagens}
                  changeSelected={(selected) =>
                    setValue('tipo_embalagem', selected)
                  }
                  disabled={
                    !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                  }
                />
              </Col>
              <Col md={3} sm={4}>
                <InputSelect
                  label="Embalagem"
                  maxLength={50}
                  placeholder="Selecione..."
                  title={
                    disabledFormItens.isDisabled
                      ? disabledFormItens.placeholder
                      : ''
                  }
                  name="des_unidade"
                  register={register}
                  isError={false}
                  control={control}
                  options={unidades}
                  changeSelected={(selected) =>
                    setValue('des_unidade', selected)
                  }
                  disabled={
                    !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                  }
                />
              </Col>
              <Col md={2} sm={4}>
                <InputNumber
                  control={control}
                  title={
                    disabledFormItens.isDisabled
                      ? disabledFormItens.placeholder
                      : ''
                  }
                  label="C/"
                  placeholder="0"
                  name="qtd_embalagem"
                  register={register}
                  maxLength={4}
                  min={1}
                  max={1000}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      const verifyQuantiy = isFractionalQuantity();
                      if (verifyQuantiy) {
                        return toast.warn(
                          'Quantidade Total não pode ser fracionada.',
                        );
                      }
                      handleAddItem();
                    }
                  }}
                  isError={!!errors.qtd_embalagem}
                  disabled={
                    !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                  }
                />
              </Col>
              <Col md={2} sm={4}>
                {isProdutoIpv ? (
                  <InputPeso
                    label="Quantidade"
                    title={
                      disabledFormItens.isDisabled
                        ? disabledFormItens.placeholder
                        : ''
                    }
                    placeholder="0"
                    name="qtd_entrada"
                    value={watchQtdEntrada || ''}
                    max={1000}
                    min={1}
                    decimals={2}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        const verifyQuantiy = isFractionalQuantity();
                        if (verifyQuantiy) {
                          return toast.warn(
                            'Quantidade Total não pode ser fracionada.',
                          );
                        }
                        handleAddItem();
                      }
                    }}
                    register={register}
                    isError={!!errors.qtd_entrada}
                    disabled={
                      !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                    }
                    control={control}
                  />
                ) : (
                  <InputNumber
                    label="Quantidade"
                    title={
                      disabledFormItens.isDisabled
                        ? disabledFormItens.placeholder
                        : ''
                    }
                    placeholder="0"
                    name="qtd_entrada"
                    onChange={(e: any) => {
                      const val = String(e.target.value).slice(0, 4);
                      setValue('qtd_entrada', val);
                      e.target.value = val;
                    }}
                    maxLength={4}
                    min={1}
                    max={1000}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        const verifyQuantiy = isFractionalQuantity();
                        if (verifyQuantiy) {
                          return toast.warn(
                            'Quantidade Total não pode ser fracionada.',
                          );
                        }
                        handleAddItem();
                      }
                    }}
                    register={register}
                    isError={!!errors.qtd_entrada}
                    disabled={
                      !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                    }
                    control={control}
                  />
                )}
              </Col>
              <Col md={2} sm={4}>
                <InputMoney
                  label="Valor Unitário"
                  title={
                    disabledFormItens.isDisabled
                      ? disabledFormItens.placeholder
                      : ''
                  }
                  placeholder="0,00"
                  name="val_tabela"
                  min={0}
                  decimals={4}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      const verifyQuantiy = isFractionalQuantity();
                      if (verifyQuantiy) {
                        return toast.warn(
                          'Quantidade Total não pode ser fracionada.',
                        );
                      }
                      handleAddItem();
                    }
                  }}
                  register={register}
                  isError={!!errors.val_tabela}
                  disabled={
                    !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                  }
                  control={control}
                />
                <div
                  className="text-end mb-0 mt-1"
                  style={{
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    marginRight: '16px',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    gap: '8px',
                  }}
                >
                  <p style={{ color: '#8850BF', fontWeight: 'bold' }}>
                    Total Tabela: {totalTabelaFormatado}
                  </p>
                  <p style={{ color: '#007BFF', fontWeight: 'bold' }}>
                    Total: {totalValorUnitarioFormatado}
                  </p>
                </div>
              </Col>
            </Row>
          </EntradaItensContainer>
        </Col>
      </Row>

      <Row className="d-flex align-items-center mt-2">
        <Col md={1} sm={4}>
          <p
            style={{
              marginTop: '16px',
              marginBottom: 0,
            }}
          >
            Totais
          </p>
        </Col>
        <Col md={11} sm={12}>
          <EntradaItensContainer>
            <Row>
              <div className="itens-container">
                <div>
                  <InputMoney
                    label="Despesas Acessórias"
                    title={
                      disabledFormItens.isDisabled
                        ? disabledFormItens.placeholder
                        : ''
                    }
                    placeholder="0,00"
                    name="val_tot_desp_acess"
                    min={0}
                    decimals={2}
                    register={register}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        const verifyQuantiy = isFractionalQuantity();
                        if (verifyQuantiy) {
                          return toast.warn(
                            'Quantidade Total não pode ser fracionada.',
                          );
                        }
                        handleAddItem();
                      }
                    }}
                    isError={!!errors.val_tot_desp_acess}
                    disabled={
                      !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                    }
                    control={control}
                  />
                </div>
                <div>
                  <InputMoney
                    label="Desconto"
                    title={
                      disabledFormItens.isDisabled
                        ? disabledFormItens.placeholder
                        : ''
                    }
                    placeholder="0,00"
                    name="val_tot_desconto"
                    min={0}
                    decimals={2}
                    register={register}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        const verifyQuantiy = isFractionalQuantity();
                        if (verifyQuantiy) {
                          return toast.warn(
                            'Quantidade Total não pode ser fracionada.',
                          );
                        }
                        handleAddItem();
                      }
                    }}
                    isError={!!errors.val_tot_desconto}
                    disabled={
                      !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                    }
                    control={control}
                  />
                </div>
                <div>
                  <InputMoney
                    label="Acréscimo"
                    title={
                      disabledFormItens.isDisabled
                        ? disabledFormItens.placeholder
                        : ''
                    }
                    placeholder="0,00"
                    name="val_tot_acrescimo"
                    min={0}
                    decimals={2}
                    register={register}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        const verifyQuantiy = isFractionalQuantity();
                        if (verifyQuantiy) {
                          return toast.warn(
                            'Quantidade Total não pode ser fracionada.',
                          );
                        }
                        handleAddItem();
                      }
                    }}
                    isError={!!errors.val_tot_acrescimo}
                    disabled={
                      !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                    }
                    control={control}
                  />
                </div>
                <div>
                  <InputMoney
                    label="Frete"
                    placeholder="0,00"
                    title={
                      disabledFormItens.isDisabled
                        ? disabledFormItens.placeholder
                        : ''
                    }
                    name="val_tot_frete"
                    min={0}
                    decimals={2}
                    register={register}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        const verifyQuantiy = isFractionalQuantity();
                        if (verifyQuantiy) {
                          return toast.warn(
                            'Quantidade Total não pode ser fracionada.',
                          );
                        }
                        handleAddItem();
                      }
                    }}
                    isError={!!errors.val_tot_frete}
                    disabled={
                      !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                    }
                    control={control}
                  />
                </div>
                <div>
                  <InputMoney
                    label="Venda Varejo"
                    title={
                      disabledFormItens.isDisabled
                        ? disabledFormItens.placeholder
                        : ''
                    }
                    placeholder="0,00"
                    name="val_tot_venda_varejo"
                    min={0}
                    decimals={2}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        const verifyQuantiy = isFractionalQuantity();
                        if (verifyQuantiy) {
                          return toast.warn(
                            'Quantidade Total não pode ser fracionada.',
                          );
                        }
                        handleAddItem();
                      }
                    }}
                    register={register}
                    isError={!!errors.val_tot_venda_varejo}
                    disabled={
                      !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                    }
                    control={control}
                  />
                </div>
                <div>
                  <InputMoney
                    label="IPI"
                    placeholder="0,00"
                    name="val_tot_ipi"
                    title={
                      disabledFormItens.isDisabled
                        ? disabledFormItens.placeholder
                        : ''
                    }
                    min={0}
                    decimals={2}
                    register={register}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        const verifyQuantiy = isFractionalQuantity();
                        if (verifyQuantiy) {
                          return toast.warn(
                            'Quantidade Total não pode ser fracionada.',
                          );
                        }
                        handleAddItem();
                      }
                    }}
                    isError={!!errors.val_tot_ipi}
                    disabled={
                      !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                    }
                    control={control}
                  />
                </div>
                <div>
                  <InputMoney
                    label="ST"
                    placeholder="0,00"
                    name="val_tot_st"
                    title={
                      disabledFormItens.isDisabled
                        ? disabledFormItens.placeholder
                        : ''
                    }
                    min={0}
                    decimals={2}
                    register={register}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                        const verifyQuantiy = isFractionalQuantity();
                        if (verifyQuantiy) {
                          return toast.warn(
                            'Quantidade Total não pode ser fracionada.',
                          );
                        }
                        handleAddItem();
                      }
                    }}
                    isError={!!errors.val_tot_st}
                    disabled={
                      !canUpdate || (canUpdate && disabledFormItens.isDisabled)
                    }
                    control={control}
                  />
                </div>
              </div>
            </Row>
          </EntradaItensContainer>
        </Col>
        <Col
          sm={12}
          className="mt-2 d-flex align-items-center justify-content-end align-self-end gap-3"
        >
          <CustomButtonNovo
            disabled={!canUpdate || (canUpdate && disabledFormItens.isDisabled)}
            title={
              disabledFormItens.isDisabled ? disabledFormItens.placeholder : ''
            }
            onClick={async () => {
              const verifyQuantiy = isFractionalQuantity();
              if (verifyQuantiy) {
                toast.warn('Quantidade Total não pode ser fracionada.');
                return;
              }
              await handleAddItem();
            }}
            label="Confirmar"
            variant="confirm"
          />
          <CustomButtonNovo
            disabled={!canUpdate || (canUpdate && disabledFormItens.isDisabled)}
            title={
              disabledFormItens.isDisabled ? disabledFormItens.placeholder : ''
            }
            onClick={() => handleClearForm()}
            label="Limpar"
            variant="clear"
          />
        </Col>
      </Row>
    </>
  );
};
